import { ur_PK_messages } from "../../locales/ur-PK/messages";
import { flattenMessages } from "../../locales/utils";

// NO TO DO, if i put messages inside redux, it's an extra state to manage
// if I use redux then I probably wouldn't need this but the syntax will
// again get long e.g. this.props.message[messageId]

new Intl.Collator(["ur-PK", "ar-AR"]);

export const DEFAULT_LOCALE = "ar-AR"; // because ur-PK is not supported
export const translations: Record<string, any> = {
    [DEFAULT_LOCALE]: flattenMessages(ur_PK_messages),
};

export class I18n {
    private locale: string;
    constructor() {
        this.locale = DEFAULT_LOCALE;
    }

    get(messageId: string) {
        return translations[this.locale][messageId];
    }
}
